import {API} from "@/Composables/api";

const getHistory = async (params = {}) => {
    return API.get(route("ai-help.history"), params);
};

const ask = async (formData, params = {}) => {
    return API.post(route("ai-help.ask"), params, formData);
};

const clearHistory = async (params = {}) => {
    return API.post(route("ai-help.clear"), params);
};

export {getHistory, ask, clearHistory};
